import { getWordSmithChat } from '@/services/apis/aiwriter'
import { ChatRole, IChatInfo } from '@/types/wordSmithChat'
import { cloneDeep } from 'lodash'
import { useEffect, useRef, useState } from 'react'
import { v4 as uuidV4 } from 'uuid'

const useWordSmith = () => {
  const [chatInfoList, setChatInfoList] = useState<IChatInfo[]>([]) // 聊天列表
  const [requesting, setRequesting] = useState(false) // 请求状态

  const chatInfoListRef = useRef<IChatInfo[]>([])
  const requestingRef = useRef(false)
  const requestIdsRef = useRef<{ [key: string]: boolean }>({}) // 每次请求的id,其值为flase表示被中断
  const currentRequestId = useRef('') // 当前请求的id

  useEffect(() => {
    requestingRef.current = requesting
  }, [requesting])

  useEffect(() => {
    // 兜底处理
    chatInfoListRef.current = chatInfoList
  }, [chatInfoList])

  const getAIAnser = async (question: string) => {
    const requestId: any = uuidV4()
    currentRequestId.current = requestId
    requestIdsRef.current[requestId] = true

    let lastIndex = chatInfoListRef.current.length - 1

    const answerData: IChatInfo = {
      id: requestId, // 需要保持和请求id一致
      role: ChatRole.ai,
      question: chatInfoListRef.current[lastIndex].question,
      answer: '',
      answerStatus: 'ing',
    }
    // 用ref承接一下，防止太快，状态来不及更新导致数据异常
    chatInfoListRef.current = [...chatInfoListRef.current, answerData]
    setChatInfoList(cloneDeep(chatInfoListRef.current))
    const index = chatInfoListRef.current.length - 1

    const reqCallBack = () => {
      return requestIdsRef.current[requestId]
    }

    try {
      const res: any = await getWordSmithChat({ text: question }, reqCallBack)
      if (!requestIdsRef.current[requestId]) {
        return
      }

      const len = chatInfoListRef.current.length
      chatInfoListRef.current[len - 1].answerStatus = 'success'
      chatInfoListRef.current[len - 1].answer = res.answer
      setChatInfoList(cloneDeep(chatInfoListRef.current))
    } catch (e) {
      if (!requestIdsRef.current[requestId]) {
        // 被主动中断的不再进一步处理
        return
      }

      chatInfoListRef.current[index].answerStatus = 'failed'
      chatInfoListRef.current[index].answer = 'AIwriter_answerfail_msg' // 多语言id
      setChatInfoList(cloneDeep(chatInfoListRef.current))
    } finally {
      setRequesting(false)
      // 请求结束不需要保留请求id
      delete requestIdsRef.current[requestId]
    }
  }

  // 发送问题
  const sendQuestion = (value: string) => {
    const data: IChatInfo = {
      id: uuidV4(),
      role: ChatRole.user,
      question: value,
    }

    // 用ref承接一下，防止太快，状态来不及更新
    chatInfoListRef.current = [...chatInfoListRef.current, data]
    setChatInfoList(cloneDeep(chatInfoListRef.current))
    setRequesting(true)
    setTimeout(() => {
      getAIAnser(value)
    })
  }

  return {
    chatInfoList,
    setChatInfoList,
    requesting,
    setRequesting,
    requestingRef,
    chatInfoListRef,
    requestIdsRef,
    currentRequestId,
    getAIAnser,
    sendQuestion,
  }
}

export default useWordSmith
